import { FC, forwardRef, useImperativeHandle, useState } from 'react'

import { Form } from '@factorialco/deprecated-design-system'

import Text from 'modules/core/components/Inputs/Text'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import GeneralForm from 'modules/employees/lib/forms/Personal/General'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  readonly?: boolean
  onChange: () => void
  ref: React.Ref<IrpfHandle>
}

export type IrpfHandle = {
  onSubmit: () => void
  isDirty: () => boolean
}

const Irpf: FC<Props> = forwardRef<IrpfHandle, Props>(({ employee, readonly, onChange }, ref) => {
  const {
    birthday_on,
    gender,
    nationality,
    phone_number,
    payment_frequency,
    preferred_name,
    pronouns,
    irpf,
    country_metadata,
    share_birthday,
  } = employee.attributes
  const [generalForm, setGeneralForm] = useState(
    new GeneralForm({
      birthday_on: birthday_on ?? '',
      gender: gender ?? '',
      nationality: nationality ?? '',
      phone_number: phone_number ?? '',
      payment_frequency: payment_frequency ?? '',
      preferred_name: preferred_name ?? '',
      pronouns: pronouns ?? '',
      ...(irpf !== null && irpf !== undefined ? { irpf } : {}),
      country_metadata: country_metadata ?? {},
      share_birthday: share_birthday ?? false,
    })
  )

  useEffect(() => {
    const {
      birthday_on,
      gender,
      nationality,
      phone_number,
      payment_frequency,
      preferred_name,
      pronouns,
      irpf,
      country_metadata,
      share_birthday,
    } = employee.attributes
    setGeneralForm(
      new GeneralForm({
        birthday_on: birthday_on ?? '',
        gender: gender ?? '',
        nationality: nationality ?? '',
        phone_number: phone_number ?? '',
        payment_frequency: payment_frequency ?? '',
        preferred_name: preferred_name ?? '',
        pronouns: pronouns ?? '',
        ...(irpf !== null && irpf !== undefined ? { irpf } : {}),
        country_metadata: country_metadata ?? {},
        share_birthday: share_birthday ?? false,
      })
    )
  }, [employee.attributes.id])
  useImperativeHandle(ref, () => ({
    onSubmit: async () => {
      if (generalForm.isDirty) {
        await asyncAction(() => {
          return Promise.all([generalForm.save(employee)])
        })
        onChange()
      }
    },
    isDirty: () => {
      return generalForm.isDirty
    },
  }))

  return (
    <Form padding={null}>
      <Text
        readonly={readonly}
        label={i18n.t('employee_form.irpf.label')}
        field={generalForm.get('irpf')}
        type="number"
        onChange={onChange}
        onBlur={() => track(trackingEvents.employee.personal.addIrpf)}
      />
    </Form>
  )
})

Irpf.displayName = 'Irpf'

export default Irpf
